import { render, staticRenderFns } from "./FocusSettings.vue?vue&type=template&id=546fb6a6&"
import script from "./FocusSettings.vue?vue&type=script&lang=js&"
export * from "./FocusSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports